// removed by extract-text-webpack-plugin
module.exports = {"FormContainer":"Departments__FormContainer__2d-p1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Departments/Departments.css
// module id = 189
// module chunks = 2